module.exports = __webpack_public_path__ + "img/4.69a376f0.jpg";